import React from 'react';
import './services.css';
import './ecommerce.css';
import bgecommerce from '../images/bgecommerce.webp';
import ArrowRight from './ArrowRights.js';

function Ecommerce() {
  return (
    <section className='ecommerce' style={{ backgroundImage: `url(${bgecommerce})` }} name='ecommerce'>
        <div className='content'>
              <p className='subtitles'>Especialistas en <strong>Ecommerce</strong></p>
                <div className='titles'>
                    <h2>Experts <sub>-</sub></h2>
                    <ArrowRight className="custom-arrow" />
                    <span className='bajada'>Construimos <strong>experiencias</strong> que conectan y transforman.</span>
                </div>
              <div className='colIndex colIndexData'>
                    <ol className='whyIndex'>
                        <li><h4><span>Estrategia Personalizada</span></h4><div className='data'><p>Cada proyecto es único. Diseñamos estrategias a medida para alcanzar tus objetivos comerciales.</p></div></li>
                        <li><h4><span>Excelencia en Ejecucion</span></h4><div className='data'><p>Nuestro equipo combina creatividad e innovación con precisión técnica para ofrecer productos digitales de clase mundial.</p></div></li>
                        <li><h4><span>Resultados Tangibles</span></h4><div className='data'><p>Nos enfocamos en soluciones que generan un impacto real: optimización de procesos, aumento de conversiones y fortalecimiento de la presencia digital.</p></div></li>
                        <li><h4><span>Atencion Exclusiva</span></h4><div className='data'><p>Sabemos que los grandes proyectos requieren compromiso. Nos convertimos en una extensión de tu equipo para garantizar el éxito en cada etapa del proceso.</p></div></li>
                    </ol>
                </div>
                <ol className='partners flexIndex'>
                  <li><img src='../images/partners/mercadolibre.webp' alt='mercadolibre'></img></li>
                  <li><img src='../images/partners/tiendanubeevolution.webp' alt='tienda nube'></img></li>
                  <li><img src='../images/partners/vtex.webp' alt='vtex'></img></li>
                  <li><img src='../images/partners/shopify.webp' alt='shopify'></img></li>
                  <li><img src='../images/partners/adobe.webp' alt='adobe'></img></li>
                </ol>
                <div className='mshops'><a href='/mshops'>Tenes un Mshops y tenes que migrar?</a></div>
          </div>
    </section>
  );
}
export default Ecommerce;